import { render, staticRenderFns } from "./ItemCSVImportInterface.vue?vue&type=template&id=7963b916&"
import script from "./ItemCSVImportInterface.vue?vue&type=script&lang=js&"
export * from "./ItemCSVImportInterface.vue?vue&type=script&lang=js&"
import style0 from "./ItemCSVImportInterface.vue?vue&type=style&index=0&id=7963b916&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect})
